export enum MobileMapAgent {
  myfc = 'myfc',
  lgup = 'lguplus',
}
